import {Expose, Type} from "class-transformer";
import ModelAccountBalanceCurrency from "@models/v2/account/ModelAccountBalanceCurrency";

export class ModelAccountWalletBalance {
  @Expose({name: "amount"})
  private _amount: number;
  @Expose({name: "currency"})
  private _currency: ModelAccountBalanceCurrency | null;

  public constructor(
    amount: number,
  ) {
    this._amount = amount;
    this._currency = null;
  }

  public get amount(): number {
    return this._amount;
  }

  public get currency(): ModelAccountBalanceCurrency | null {
    return this._currency;
  }

  public set currency(value: ModelAccountBalanceCurrency) {
    this._currency = value;
  }

  public set amount(value: number) {
    this._amount = value;
  }
}

export default class ModelAccountWallet {
  @Expose({name: "enabled"})
  private _enabled: boolean;
  @Expose({name: "balance"})
  @Type(() => ModelAccountWalletBalance)
  private readonly _balance: ModelAccountWalletBalance;

  public constructor(
    enabled: boolean,
    balance: ModelAccountWalletBalance,
  ) {
    this._enabled = enabled;
    this._balance = balance;
  }

  public get enabled(): boolean {
    return this._enabled;
  }

  public set enabled(enabled: boolean) {
    this._enabled = enabled;
  }

  public get balance(): ModelAccountWalletBalance {
    return this._balance;
  }
}
